/* Storefront brand spelling. Only display text and accessible labels are changed.
   URLs, identifiers, form values, scripts and images are never rewritten. */
(() => {
  'use strict';
  const brand = /(?<![\p{L}\p{N}_/@.\-])femi(?:[.·]|[ \u00a0])?eko(?=s?(?:[^\p{L}\p{N}_/@]|$))(?!\.[a-z])/giu;
  const protectedText = /(https?:\/\/[^\s<>"']+|[\w.+-]+@[\w.-]+\.[a-z]{2,})/gi;
  const skip = 'script,style,noscript,textarea,input,code,pre,[contenteditable]:not([contenteditable="false"]),[data-fe-brand-preserve]';
  const attrs = ['alt','title','aria-label','placeholder'];
  function normalize(value) {
    return value.split(protectedText).map((part,index) => index % 2 ? part : part.replace(brand,'Femieko')).join('');
  }
  function text(node) {
    if (!node.parentElement || node.parentElement.closest(skip)) return;
    const next = normalize(node.data);
    if (next !== node.data) node.data = next;
    // Preserve the approved spelling even inside uppercase/lowercase headings.
    if (!next.match(brand) || node.parentElement.namespaceURI !== 'http://www.w3.org/1999/xhtml') return;
    if (!['uppercase','lowercase'].includes(getComputedStyle(node.parentElement).textTransform)) return;
    const fragment = document.createDocumentFragment(); let offset = 0;
    for (const match of next.matchAll(brand)) {
      fragment.append(document.createTextNode(next.slice(offset,match.index)));
      const span = document.createElement('span');
      span.style.setProperty('text-transform','none','important');
      span.textContent = match[0]; fragment.append(span);
      offset = match.index + match[0].length;
    }
    fragment.append(document.createTextNode(next.slice(offset)));
    node.replaceWith(fragment);
  }
  function labels(el) {
    if (el.closest(skip)) return;
    for (const attr of attrs) {
      if (!el.hasAttribute(attr)) continue;
      const value = el.getAttribute(attr), next = normalize(value);
      if (value !== next) el.setAttribute(attr,next);
    }
  }
  function scan(root) {
    if (root.nodeType === Node.TEXT_NODE) { text(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE && root !== document) return;
    if (root.nodeType === Node.ELEMENT_NODE) {
      if (root.closest(skip)) return;
      labels(root);
    }
    const walker = document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(text);
    root.querySelectorAll('[alt],[title],[aria-label],[placeholder]').forEach(labels);
  }
  scan(document);
  const pending = new Set(); let scheduled = false;
  function flush() {
    scheduled = false;
    for (const node of pending) if (node.isConnected) scan(node);
    pending.clear();
  }
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'childList') record.addedNodes.forEach(node => pending.add(node));
      else pending.add(record.target);
    }
    if (!scheduled && pending.size) { scheduled = true; queueMicrotask(flush); }
  }).observe(document.documentElement,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:attrs});
})();
